import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { getDevelopmentApiHeaders } from '../../../api/developmentHeaders';

export type SurveyClientRuntime = 'surveyjs' | 'hexia';

type RuntimeResponse = {
  runtime?: string;
  revision?: number;
};

const runtimeCacheKey = 'hexia:survey-runtime-selection';

const normalizeRuntime = (runtime?: string): SurveyClientRuntime => runtime?.toLowerCase() === 'hexia' ? 'hexia' : 'surveyjs';

export const getSurveyRuntimeSelection = async (): Promise<SurveyClientRuntime> => {
  const baseUrl = Constants.expoConfig?.extra?.baseUrl;

  try {
    const response = await fetch(`${baseUrl}/api/portal/survey-runtime`, {
      headers: {
        Accept: 'application/json',
        ...getDevelopmentApiHeaders(baseUrl),
      },
    });

    if (!response.ok) {
      throw new Error(`Survey runtime request failed with ${response.status}.`);
    }

    const result = await response.json() as RuntimeResponse;
    const runtime = normalizeRuntime(result.runtime);
    await AsyncStorage.setItem(runtimeCacheKey, runtime);
    return runtime;
  } catch {
    // An offline session must keep using the last environment choice. If no
    // choice has ever been cached, SurveyJS is the safe compatibility default.
    return normalizeRuntime(await AsyncStorage.getItem(runtimeCacheKey) ?? undefined);
  }
};
